import React from 'react';
import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  TelegramShareButton,
  ViberShareButton,
  WhatsappShareButton,
} from 'react-share';
import useLanguage from '../../../../../hooks/useLanguage';

import FacebookIcon from '../../../../../svg/facebook.svg';
import PinterestIcon from '../../../../../svg/pinterest.svg';
import TwitterIcon from '../../../../../svg/twitter.svg';
import TelegramIcon from '../../../../../svg/telegram.svg';
import ViberIcon from '../../../../../svg/viber.svg';
import WhatsappIcon from '../../../../../svg/whatsapp.svg';
import Star from '../../../../../svg/star_footer.svg';

const ArticleShare = () => {
  const langToggle = useLanguage;
  const link = 'https://shoschool.com/';

  return (
    <div className="article-share" data-scroll-section>
      <div className="content-wrapper">
        <ul className="share">
          <li className="share-item">
            <p className="share-title">
              {langToggle('Поділитись:', 'Поделиться:')}
            </p>
          </li>
          <li className="share-item">
            <FacebookShareButton url={link}>
              <span className="react-share__ShareButton-title">Facebook</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <FacebookIcon className="react-share__ShareButton-icon" />
              </span>
            </FacebookShareButton>
          </li>
          <li className="share-item">
            <PinterestShareButton url={link}>
              <span className="react-share__ShareButton-title">Pinterest</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <PinterestIcon className="react-share__ShareButton-icon" />
              </span>
            </PinterestShareButton>
          </li>
          <li className="share-item">
            <TwitterShareButton url={link}>
              <span className="react-share__ShareButton-title">Twitter</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <TwitterIcon className="react-share__ShareButton-icon" />
              </span>
            </TwitterShareButton>
          </li>
          <li className="share-item">
            <TelegramShareButton url={link}>
              <span className="react-share__ShareButton-title">Telegram</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <TelegramIcon className="react-share__ShareButton-icon" />
              </span>
            </TelegramShareButton>
          </li>
          <li className="share-item">
            <ViberShareButton url={link}>
              <span className="react-share__ShareButton-title">Viber</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <ViberIcon className="react-share__ShareButton-icon" />
              </span>
            </ViberShareButton>
          </li>
          <li className="share-item">
            <WhatsappShareButton url={link}>
              <span className="react-share__ShareButton-title">Whatsapp</span>
              <span className="react-share__ShareButton-icon__wrapper">
                <Star className="react-share__ShareButton-icon-star" />
                <WhatsappIcon className="react-share__ShareButton-icon" />
              </span>
            </WhatsappShareButton>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ArticleShare;
